import { render, staticRenderFns } from "./recapTemplate.vue?vue&type=template&id=61c5bdb5&scoped=true&"
import script from "./recapTemplate.vue?vue&type=script&lang=js&"
export * from "./recapTemplate.vue?vue&type=script&lang=js&"
import style0 from "./recapTemplate.vue?vue&type=style&index=0&id=61c5bdb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c5bdb5",
  null
  
)

export default component.exports